import React from 'react';
import './Loader.scss';
import loader from '../../assets/images/loader.gif';

interface PropData {
  show: boolean;
  message?: string;
}

const Loader = ({ show, message }: PropData) => {
  if (!show) return null;

  return (
    <div className="custom-loader-wrapper">
      <div className="custom-loader-content">
        <img src={loader} alt="Loading..." className="custom-loader-image" />
        <div className="custom-loader-text">{message }</div>
      </div>
    </div>
  );
};

export default Loader;
